import Typography from '@material-ui/core/Typography'
import Page from 'organization/Event/Page'
import React, {useState} from 'react'
import {useEvent} from 'Event/EventProvider'
import {api, obvioUrl} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'
import Button from '@material-ui/core/Button'
import {obvioRoutes} from 'obvio/Routes'
import {useSetEventAuthRoute} from 'organization/Event/Services/Apps/HighLevel/AuthCallbackHandler'

export default function LinkPage() {
  const {link, isProcessing} = useLink()

  return (
    <Page>
      <Typography variant="h4">High Level</Typography>
      <p>
        Click the button below to link obv.io with High Level.
        <br />
        You will be redirected to High Level to complete authorization.
      </p>
      <Button
        color="primary"
        variant="contained"
        disabled={isProcessing}
        onClick={link}
        aria-label="authorize"
      >
        Authorize
      </Button>
    </Page>
  )
}

function useLink() {
  const {client} = useOrganization()
  const {event} = useEvent()
  const [isProcessing, setIsProcessing] = useState(false)
  const redirectUrl = useRedirectUrl()
  const setEventAuthRoute = useSetEventAuthRoute()

  const linkUrl = api(`/events/${event.id}/integrations/high_level/link`)

  const link = () => {
    if (isProcessing) {
      return
    }

    setIsProcessing(true)

    client
      .post<{auth_url: string}>(linkUrl, {
        redirect_url: redirectUrl,
      })
      .then(({auth_url}) => {
        // Redirect to High Level
        window.location.href = auth_url
        setEventAuthRoute()
      })
      .catch(() => {
        setIsProcessing(false)
      })
  }

  return {link, isProcessing}
}

/**
 * Mailchimp only accepts a single Redirect URL that's registered at the
 * app level, so we need to specify a top-level/obvio route.
 *
 * @returns
 */
export function useRedirectUrl() {
  return `${obvioUrl(obvioRoutes.highlevel.auth)}`
}
